import { Icons, Typography, YStack } from '@usepepper/sprout-kit-ui';
import { NavIcon } from '@/experiences/shared/components/nav-icon';
import { NavItemIcon } from '@/domain/navigation/types';
import { useTheme } from '@/contexts/theme-context';

const ITEM_SIZE = 80;
const ICON_SIZE = 20;

interface BottomNavItemProps {
  active?: boolean;
  icon?: NavItemIcon;
  iconUrl?: string;
  label?: string;
  onPress: () => void;
}

export const BottomNavItem: React.FC<BottomNavItemProps> = ({
  active,
  icon,
  iconUrl,
  label,
  onPress,
}) => {
  const theme = useTheme();

  const iconColor = active
    ? theme.sk.color.icon.primary
    : theme.sk.color.icon.secondary;

  return (
    <YStack
      accessibilityRole="button"
      accessibilityState={{ selected: Boolean(active) }}
      alignItems="center"
      gap="$4"
      justifyContent="center"
      minWidth={0}
      onPress={onPress}
      paddingVertical="$8"
      width={ITEM_SIZE}
    >
      <NavIcon
        color={iconColor}
        fallback={<Icons.CircleDashed color={iconColor} size={ICON_SIZE} />}
        icon={icon}
        iconUrl={iconUrl}
        size={ICON_SIZE}
      />
      {label ? (
        <Typography
          bold={Boolean(active)}
          color={active ? '$textPrimary' : '$textSecondary'}
          numberOfLines={1}
          size="$2xs"
          textAlign="center"
          variant="caption"
          width="100%"
        >
          {label}
        </Typography>
      ) : null}
    </YStack>
  );
};
